<template>
<div class="">
  <br>
  <front-navigation></front-navigation>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-4">
        <side-bar></side-bar>
      </div>
      <div class="col-md-7">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-content">
                <div class="container">

                  <h4 class="text-center" v-if="route === 'ActivitySelection'">Accomodation Selection Complete</h4>
                  <hr>
                  <h6 class="text-center">
                    Conservation fee is mandatory but all other services are optional
                  </h6>
                  <br>
                  <br>
                  <h3>Activities</h3>
                  <div class="row">
                    <div class="col-md-12">
                      <inventory-booking></inventory-booking>
                    </div>
                    <hr>
                  </div>
                  <br>
                  <br>
                  <h3>More Accommodation</h3>
                  <div class="row">
                    <div class="col-md-12">
                      <facility-booking></facility-booking>
                    </div>
                    <hr>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br>
        <div class="row">
          <div class="col-md-4">
            <button class="btn green btn-block" @click="openBookingInfo()">Proceed to Checkout</button>
          </div>
          <div class="col-md-4">
            <button class="btn btn-info btn-block" @click="changeRoom()">Amend Booking</button>
          </div>
          <div class="col-md-4">
            <button class="btn btn-warning btn-block" @click="clearData()">Start Over</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import FrontNavigation from '../Repeated/FrontNavigation'
import SideBar from '../Repeated/SideBar'
import Datepicker from 'vuejs-datepicker'
import InventoryBooking from '../../Back/Bookings/Snippets/InventoryBooking'
import FacilityBooking from '../../Back/Bookings/Snippets/FacilityBooking'
export default {
  components: {
    FacilityBooking,
    InventoryBooking,
    SideBar,
    FrontNavigation,
    Datepicker },
  name: 'activity-selection',
  data () {
    return {
      route: this.$route.name,
      activity: {
        date: '',
        public_id: '',
        adult: 0,
        children: 0
      },
      vehicle: {
        seater6: 0,
        seater14: 0,
        seater60: 0
      },
      maxAdult: 0,
      maxChild: 0,
      inventory: []
    }
  },
  computed: {
  },
  created () {
    if (localStorage.getItem('facility_data') !== null) {
      this.$store.commit('BROWSER_FACILITIES', JSON.parse(localStorage.getItem('facility_data')))
    }
  },
  methods: {
    changeRoom: function () {
      this.$router.push({
        name: 'Reservation'
      })
    },
    postBooking: function () {
      var data = {
        booking: this.booking,
        localBooking: JSON.parse(localStorage.getItem('booking')),
        facilities: JSON.parse(localStorage.getItem('browser_facility')),
        inventory: JSON.parse(localStorage.getItem('browser_inventory')),
        facility_id: this.$route.params.facility_id
      }
      this.$store.dispatch('post_booking', data)
    },
    openBookingInfo: function () {
      var vehicles = this.vehicleTotal
      if (vehicles > 0) {
        if (this.$route.name === 'ActivitySelection') {
          this.$router.push({
            name: 'BookingInformation'
          })
        } else if (this.$route.name === 'ExpressCheckout') {
          this.$router.push({
            name: 'ExpressBookingInformation'
          })
        }
      } else {
        alert('Vehicle is mandatory')
      }
    }
  }
}
</script>

<style scoped>

</style>
